import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MasGarantiaComponent } from './pages/mas-garantia/mas-garantia.component';
import { FindByTicketComponent } from './pages/find-by-ticket/find-by-ticket.component';

import { BannerComponent } from './components/banner/banner.component';
import { WarrantyCoverageComponent } from './components/warranty-coverage/warranty-coverage.component';
import { ItemFailureComponent } from './components/item-failure/item-failure.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { WarrantyInfoComponent } from './components/warranty-info/warranty-info.component';
import { MaterialModule } from '../material-module/material.module';
import { MasGarantiaFooterComponent } from './components/mas-garantia-footer/mas-garantia-footer.component';
import { MasGarantiaHeaderComponent } from './components/mas-garantia-header/mas-garantia-header.component';
import { MasGarantiaNavbarComponent } from './components/mas-garantia-navbar/mas-garantia-navbar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MasGarantiaRoutingModule } from './mas-garantia-routing.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    MasGarantiaComponent,
    BannerComponent,
    WarrantyCoverageComponent,
    ItemFailureComponent,
    FaqsComponent,
    WarrantyInfoComponent,
    FindByTicketComponent,
    MasGarantiaFooterComponent,
    MasGarantiaHeaderComponent,
    MasGarantiaNavbarComponent,
    PrivacyPolicyComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FontAwesomeModule,
    MasGarantiaRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    MasGarantiaComponent,
    FindByTicketComponent
  ]
})
export class MasGarantiaModule { }
